import { Typography } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

const SectionStatistics = ({ section }) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-300">
      <div className="flex gap-100">
        <p
          className="section-vertical-bar-statistics-label body-s-regular"
          style={{ color: section.color }}
        >
          {t("labels.questions")}
        </p>

        <p
          className="section-vertical-bar-statistics-label body-s-medium"
          style={{ color: section.color }}
        >
          {section.answeredRequiredQuestionsCount +
            section.answeredOptionalQuestionsCount}
          /{section.requiredQuestionsCount + section.optionalQuestionsCount}
        </p>
      </div>

      <div className="flex gap-100">
        <p
          className="section-vertical-bar-statistics-label body-s-regular"
          style={{ color: section.color }}
        >
          {t("survey.labels.dataBlock")}
        </p>

        <p
          className="section-vertical-bar-statistics-label body-s-medium"
          style={{ color: section.color }}
        >
          {section.answeredBlocksCount}/{section.requiredBlocksCount}
        </p>
      </div>
    </div>
  );
};

SectionStatistics.propTypes = {
  section: PropTypes.object.isRequired,
};

const SectionVerticalBar = ({ section }) => {
  return (
    <div>
      <div
        style={{ backgroundColor: section.color }}
        className="section-vertical-bar-color full-width"
      />

      <div className="flex justify-between items-center full-width">
        <h4 className="header-m-medium" style={{ color: section.color }}>
          {section.title}
        </h4>

        {section?.statistics && (
          <SectionStatistics section={section.statistics} />
        )}
      </div>
    </div>
  );
};

SectionVerticalBar.propTypes = {
  section: PropTypes.object.isRequired,
};

export default SectionVerticalBar;
